// 声明全局回调
import { BusinessCode } from '../common/onCommonResult';
import { isClient } from './utils';
var WEB_CALLBACK = [];
var onSuccessCache = Object.create(null);
var onFailCache = Object.create(null);
if (isClient) {
    window.__EMONEY_MOBILE_WEB_CALLBACK__ = WEB_CALLBACK;
    window.onSuccess = function (type, callbackParams) {
        console.info('onSuccess', type, callbackParams);
        if (onSuccessCache[callbackParams]) {
            onSuccessCache[callbackParams](type);
        }
    };
    window.onFail = function (type, callbackParams) {
        console.info('onFail', type, callbackParams);
        if (onFailCache[callbackParams]) {
            onFailCache[callbackParams](type);
        }
    };
}
/**
 * 回调函数代理
 */
export function callbackProxy(options) {
    var middlewareCallback = options.callback || function () { };
    var result = options;
    var callback = function (json) {
        if (typeof json === 'string') {
            try {
                json = JSON.parse(json);
            }
            catch (e) {
                console.warn("\u56DE\u8C03\u53C2\u6570(".concat(json, ")\u9519\u8BEF\uFF0C\u65E0\u6CD5\u89E3\u6790\u4E3Ajson\uFF0C"), e);
            }
        }
        if (middlewareCallback) {
            middlewareCallback(json);
        }
    };
    if (options.onSuccess || options.onFail) {
        var timeStr = new Date().getTime() + '';
        result.callbackParams = timeStr;
        onSuccessCache[timeStr] = options.onSuccess || function () { };
        onFailCache[timeStr] = options.onFail || function () { };
    }
    else if (options.onCommonResult) {
    }
    else {
        result.callback = "__EMONEY_MOBILE_WEB_CALLBACK__[".concat(WEB_CALLBACK.push(callback) - 1, "]");
    }
    return result;
}
var onCommonResultCallback = Object.create(null);
var hasWatchOnCommonResult = false;
function watchOnCommonResult() {
    if (isClient && !hasWatchOnCommonResult) {
        hasWatchOnCommonResult = true;
        window.onCommonResult = function (retCode, businessCode, strRes) {
            var callbacks = onCommonResultCallback[businessCode];
            if (callbacks && callbacks.length) {
                try {
                    var result_1 = strRes;
                    switch (businessCode) {
                        case BusinessCode.GoldStockBroker:
                            result_1 = JSON.parse(strRes);
                            break;
                    }
                    var copies = callbacks.slice(0);
                    callbacks.length = 0;
                    copies.forEach(function (element) {
                        if (element) {
                            element(retCode, result_1);
                        }
                    });
                }
                catch (error) {
                    console.error('[@em/ym] onCommonResult:', error);
                }
            }
        };
    }
}
export function onCommonResult(businessCode, callback) {
    if (!onCommonResultCallback[businessCode]) {
        onCommonResultCallback[businessCode] = [];
    }
    onCommonResultCallback[businessCode].push(callback);
    watchOnCommonResult();
}
//# sourceMappingURL=callBackProxy.js.map